import Header from "../components/Header";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


const ContactSupport = () => {
  return (
    <>
      <Header />

      <section className="container mt-5">
        <div className="d-block d-md-none text-start mb-4">
          <Link
            to="/dashboard"
            className="text-decoration-none fw-bold text-orange"
            style={{ color: "#f5721e" }}
          >
            <strong>← Tableau de bord</strong>
          </Link>
        </div>
        <h1 className="mb-5">Contactez nous !</h1>
        <div className="row  mx-n2 mb-3 ">
          <div className="col-lg-4 col-sm-6 px-2">
            <a
              href="https://wa.me/+22955952589"
              target="_blank"
              className="text-decoration-none"
            >
              <div className="card">
                <div className="card-body text-center">
                  <div className="mb-5 bg-light">
                    <i
                      className="fab fa-whatsapp"
                      style={{ fontSize: "50px", color: "green" }}
                    ></i>
                  </div>
                  <h5 className="h3 font-weight-bolder">Whatsapp </h5>
                </div>
              </div>
            </a>
          </div>

          <div className="col-lg-4 col-sm-6 px-2">
            <a
              href="mailto:luciejerom@gmail.com?subject=Demande d'informations&body=Bonjour, je souhaite avoir plus d'informations concernant..."
              className="text-decoration-none"
            >
              <div className="card">
                <div className="card-body text-center">
                  <div className="mb-5 bg-light">
                    <i
                      className="fas fa-envelope"
                      style={{ fontSize: "50px", color: "red" }}
                    ></i>
                  </div>
                  <h5 className="h3 font-weight-bolder text-black">Gmail</h5>
                </div>
              </div>
            </a>
          </div>

          <div className="col-lg-4 col-sm-6 px-2">
            <a href="tel:+2290155952589" className="text-decoration-none">
              <div className="card">
                <div className="card-body text-center">
                  <div className="mb-5 bg-light">
                    <i
                      className="fas fa-phone"
                      style={{ fontSize: "50px", color: "blue" }}
                    ></i>
                  </div>
                  <h5 className="h3 font-weight-bolder text-black">
                    Téléphone{" "}
                  </h5>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSupport;
